/**
 * editing redux actions
 * 
 * @author    Jens Gruschel, Maurizio Tidei
 * @copyright © 2018 contexagon GmbH
 */


import {
    LOAD_OBJECT,
    SAVE_OBJECT,
    SWITCH_OBJECT,
    CREATE_NEW_OBJECT,
    CREATE_NEW_REFERENCE,
    CREATE_NEW_ELEMENT,
    PUSH_ELEMENT,
    POP_EDIT_STACK,
    ASSIGN_ELEMENT,
    REMOVE_FIELD_ELEMENT,
    MOVE_FIELD_ELEMENT,
    UPDATE_WHOLE_OBJECT,
    UPDATE_OBJECT_VALUE,
    UPDATE_OBJECT_MAP,
    DELETE_OBJECT_TAG,
    ADD_OBJECT_TAG,
    LOAD_ALL_TAGS,
    CHANGE_TAB,
    SET_EDIT_FLAG,
    FETCH_REFERENCED_OBJECTS,
    FETCH_REFERENCABLE_OBJECTS,
    EXECUTE_OBJECT_COMMAND
} from './consts';


export const createNewObjectAction = (type, fields) => ({
    type: CREATE_NEW_OBJECT,
    newObject: {
        type: type,
        fields: fields,
        tags: []
    }
});

export const createNewObjectReferenceAction = (fieldPath, type, fields, flags) => ({
    type: CREATE_NEW_REFERENCE,
    newObject: {
        type: type,
        fields: fields,
        tags: []
    },
    fieldPath: fieldPath,
    flags: flags
});

export const createNewElementAction = (fieldPath, type, fields) => ({
    type: CREATE_NEW_ELEMENT,
    newObject: {
        type: type,
        fields: fields
    },
    fieldPath: fieldPath
});

export const saveObjectSuccessAction = (object) => ({
    type: SAVE_OBJECT,
    object: object
});

export const switchObjectAction = (objectId, accessLevel) => ({
    type: SWITCH_OBJECT,
    objectId: objectId,
    accessLevel: accessLevel
});

export const loadObjectAction = (object, objectInfo, params) => ({
    type: LOAD_OBJECT,
    object: object,
    objectInfo: objectInfo,
    params: params
});

export const fetchReferencedObjectsAction = (objectList) => ({
    type: FETCH_REFERENCED_OBJECTS,
    objectList: objectList
});

export const fetchReferencableObjectsAction = (objectList) => ({
    type: FETCH_REFERENCABLE_OBJECTS,
    objectList: objectList
});

export const pushElementAction = (fieldPath, element, params) => ({
    type: PUSH_ELEMENT,
    fieldPath: fieldPath,
    element: element,
    params: params
})

export const updateWholeObjectAction = (objectId, object) => ({
    type: UPDATE_WHOLE_OBJECT,
    objectId: objectId,
    object: object
});

export const updateObjectValueAction = (objectId, fieldPath, value) => ({
    type: UPDATE_OBJECT_VALUE,
    objectId: objectId,
    fieldPath: fieldPath,
    value: value
});

export const updateObjectMapAction = (objectList) => ({
    type: UPDATE_OBJECT_MAP,
    objectList: objectList
});

export const popEditStackAction = () => ({
    type: POP_EDIT_STACK
});

export const assignElementAction = (value) => ({
    type: ASSIGN_ELEMENT,
    value: value
});

export const removeFieldElementAction = (objectId, fieldPath, index, flags) => ({
    type: REMOVE_FIELD_ELEMENT,
    objectId: objectId,
    fieldPath: fieldPath,
    index: index,
    flags: flags
});

export const moveFieldElementAction = (objectId, fieldPath, fromIndex, toIndex) => ({
    type: MOVE_FIELD_ELEMENT,
    objectId: objectId,
    fieldPath: fieldPath,
    fromIndex: fromIndex,
    toIndex: toIndex
});

export const deleteTagAction = (objectId, index) => ({
    type: DELETE_OBJECT_TAG,
    objectId: objectId,
    index: index
});

export const addTagAction = (objectId, tag) => ({
    type: ADD_OBJECT_TAG,
    objectId: objectId,
    tag: tag
});

export const loadAllTagsSuccessAction = (tags) => ({
    type: LOAD_ALL_TAGS,
    tags: tags
});

export const changeTabAction = (tabKey, index) => ({
    type: CHANGE_TAB,
    tabKey: tabKey,
    index: index
});

export const setEditFlagAction = (flagName, flagValue) => ({
    type: SET_EDIT_FLAG,
    flagName: flagName,
    flagValue: flagValue
});

export const executeObjectCommandAction = (objectId, restcall) => ({
    type: EXECUTE_OBJECT_COMMAND,
    objectId: objectId,
    restcall: restcall
});